import css from 'styled-jsx/css';

const AvailabilityLocationStyles = css`
  .delivery-option-location {
    .delivery-location-text {
      color: #333;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
`;

export { AvailabilityLocationStyles };
